<template>
  <div id="app" class="areaApp" :class="changeStorePageBackgroundStyle" ontouchstart="">
    <app-loading ref="loadingView"></app-loading>
<div class="appWrap" id="js-scroll" v-scroll='handleScrollApp' ref="interfaceParts" @mouseenter.self="appearNavigation" @mouseleave.self="disappearNavigation"><!-- @touchstart="toggleNavigation">-->
      <header>
        <app-nav :nav-icon=iconMenu ref="nav"></app-nav>
        <app-contact-menu v-bind:sideButton=sideButton></app-contact-menu>
      </header>
      <app-breadcrumb :present-page='setPresentPage'></app-breadcrumb>
      <app-share-button/>
      <app-inner-nav :inner-nav-info='setInnerNav' v-show="needInnerNav"></app-inner-nav>
    </div>
    <router-view @sideButton="setTarget" class="pointerEventAuto" @mouseenter.native="appearNavigation" @mouseleave.native="disappearNavigation" ref="view" @touchmove.native="tapCheck" @touchend.native="toggleNavigation"></router-view>
    <app-contact-button v-show="needContactButton"></app-contact-button>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppNav from '@/components/Nav.vue'
import AppContactMenu from '@/components/ContactMenu.vue'
import AppFooter from '@/components/Footer.vue'
import AppLoading from '@/components/Loading.vue'
import AppBreadcrumb from '@/components/Breadcrumb.vue'
import AppInnerNav from '@/components/InnerNav.vue'
import AppBackLine from '@/components/BackLine.vue'
import AppContactButton from '@/components/ContactButton.vue'
import AppShareButton from '@/components/Share.vue'
/*import luxy from "luxy.js"*/

//import axios from 'axios'

var idToken = ""
var presentPage = ""
var innerNavInfo = []
var sideButton = ""
var appBackground = ""
var navIcon = false
var onMouse = false

export default {
  name:'App',
/* vue-head 表記内容 */
/*
  head: {
    title() {
      return {
        inner: this.$route.name,
        separator: '|',
        complement: this.$store.getters.siteName,
      }
    },
    meta:function() {
			return [
				{ name: 'description', content: this.description, id:'Desc' },
				{ name: 'keywords', content: this.keywords, id:'Keyw'},
				{ property: 'og:url', content: this.isUrl, id:'OgUrl' },
				{ property: 'og:type', content: this.ogType, id:'OgType' },
				{ property: 'og:title', content: this.isTitle, id:'OgTitle' },
				{ property: 'og:description', content: this.description, id:'OgDesc' },
				{ property: 'og:site_name', content: this.ogSiteName, id:'OgSite' },
				{ property: 'og:image', content: this.ogImage, id:'OgImage' },
			]
    },
		link: function() {
			return [
				{ rel: 'canonical', href: 'https://toyoshimaseimitsu.co.jp/customer/contact' },
			]
		},
	},
*/
  head: {
    title() {
      return {
        inner: this.$store.getters.currentTitle,
        separator: '|',
        complement: this.$store.getters.siteName,
      }
    },
    meta:function() {
			return [
				{ name: 'description', content: this.$store.getters.currentDescription, id:'Desc' },
				{ name: 'keywords', content: this.$store.getters.currentKeywords, id:'Keyw'},
				{ property: 'og:url', content: this.$store.getters.currentOgUrl, id:'OgUrl' },
				{ property: 'og:type', content: this.$store.getters.currentOgType, id:'OgType' },
				{ property: 'og:title', content: this.$store.getters.currentTitle, id:'OgTitle' },
				{ property: 'og:description', content: this.$store.getters.currentDescription, id:'OgDesc' },
				{ property: 'og:site_name', content: this.$store.getters.siteName, id:'OgSite' },
				{ property: 'og:image', content: this.$store.getters.currentOgImage, id:'OgImage' },
			]
    },
		link: function() {
			if(this.$store.getters.linkCanonical !== '' ) {
				return [
					{ rel: 'canonical', href: this.$store.getters.linkCanonical, id:'Canon'},
				]
			} else {
				return [
					{ rel: '', href:'', id:'Canon'},
				]
			}
		},
/* ld+jsonを外部化*/
		script: function() {
			return [
				{ type: 'application/ld+json', inner: this.$store.getters.ldJsonCommon, async: true, id:'LdJson'},
				{ type: 'application/ld+json', inner: this.$store.getters.ldJsonBreadcrumb, id:'LdJsonBreadcrumb'},
			]
		},
/* css外部化
		style: function() {
			return [
				{ type: 'text/css', inner: this.$store.getters.cssPage, undo: false, id:'ExternalCSS' },
			]
		},
*/
	},
  components:{ AppLoading, AppFooter, AppNav, AppContactMenu, AppBreadcrumb, AppInnerNav, AppBackLine, AppContactButton, AppShareButton,
  },
  data() {
    return {
      idToken,
      presentPage,
      sideButton,
      appBackground:'appBackgroundBase',
      innerNavInfo,
      navIcon,
      hash:this.$route.hash,
      onMouse,
			touchMonitor:false,    //true:フリック/スワイプ中 false:なし
			loadedJson:false,
    }
  },
  computed:{
    setPresentPage:function() {
      return presentPage = this.$route.path
    },
    setInnerNav:function() {
      return innerNavInfo = this.$store.getters.pageSectionInfo
    },
    needInnerNav:function() {
      return this.$route.meta.needsInnerNav
    },
    needContactButton:function() {
      return this.$route.meta.needsContactButton
    },
    iconMenu:function() {
    },
    changeStorePageBackgroundStyle:function() {
      return this.$store.getters.pageBackgroundStyle? this.$store.getters.pageBackgroundStyle:'appBackgroundBase'
    },
		ldJson:function() {
			return this.$store.getters.ldJsonCommon
		},
		cssPage:function() {
			return this.$store.getters.cssPage
		},
  },
  watch:{
//これにより更新イベントが発生するようになる
		ldJson:function() {
			this.$nextTick(() => {
				this.$emit('updateHead')
//this._log(this.$store.getters.ldJsonCommon)
			})
		},
/*
		cssPage:function() {
			this.$nextTick(() => {
				this.$emit('updateHead')
			})
		},
*/
  },

  beforeCreate:function() {console.log("beforeCreate "+this.$options.name)

/*外部css読み込む*/
/*
		this.$store.dispatch('importJsonAsync', {
list:'updateCssPage', 
url:'https://toyoshimaseimitsu.co.jp/asset/css/page.css'
		})
*/
//外部ld+jsonファイルを読み込む jsonパースする処理を避けたい
		this.$store.dispatch('importTextAsync', {
list:'updateLdJsonCommon', 
url:'https://toyoshimaseimitsu.co.jp/asset/structured/structured-data.json'
		})

//外部情報ファイルを読み込む
		this.$store.dispatch('importJsonAsync', {
list:'updateOriginListInformation', 
url:'https://toyoshimaseimitsu.co.jp/asset/data/information.json'
		})
		this.$store.dispatch('importJsonAsync', {
list:'updateOriginListEquipment', 
url:'https://toyoshimaseimitsu.co.jp/asset/data/equipment.json'
		})
		this.$store.dispatch('importJsonAsync', {
list:'updateOriginListMaterial', 
url:'https://toyoshimaseimitsu.co.jp/asset/data/material.json'
		})
		this.$store.dispatch('importJsonAsync', {
list:'updateOriginListProducts', 
url:'https://toyoshimaseimitsu.co.jp/asset/data/products.json'
		})
		this.$store.dispatch('importJsonAsync', {
list:'updateOriginListOfficial', 
url:'https://toyoshimaseimitsu.co.jp/asset/data/official.json'
		})

		this.$store.dispatch('importJsonAsync', {
list:'updateOriginListProfile', 
url:'https://toyoshimaseimitsu.co.jp/asset/data/profile.json'
		})
		this.$store.dispatch('importJsonAsync', {
list:'updateOriginListHistory', 
url:'https://toyoshimaseimitsu.co.jp/asset/data/history.json'
		})
		this.$store.dispatch('importJsonAsync', {
list:'updateOriginListRecruit', 
url:'https://toyoshimaseimitsu.co.jp/asset/data/recruit.json'
		})
	},

  created:function() {this._log("created "+this.$options.name)
	},

  beforeMount:function() {this._log("beforeMount "+this.$options.name)
	},

  mounted:function() {this._log("mounted "+this.$options.name)

		document.querySelector('body').setAttribute('ontouchstart', "")
/*    luxy.init({wrapper:"#Luxy"})*/

/*
この後子ページ＆コンポーネントの生成へと入っていくので、ここで
上記の読み込み状況を監視し止めておけばOKなのだが
*/
//		this.$refs.loadingView.appear()
  },

  beforeUpdate:function() {this._log("beforeUpdate "+this.$options.name)

    if(this.$route.meta.interfaceParts) {
      this.$refs.interfaceParts.classList.add("appearInterface")
    } else {
      this.$refs.interfaceParts.classList.remove("appearInterface")
    }
//ローディング
//この状態だと、背景などdataに登録した変数へのアクセスで、ページ途中でもローディングが発生する
//update前後のurlからページ内かどうかを判断する
//this._log(this.$route.path)
//this._log(this.presentPage)

    if(this.$route.path != this.presentPage) {
      this.$refs.loadingView.appear()
      this.presentPage = this.$route.path
this._log("START LOADING")
    }
  },

  updated:function() {this._log("updated "+this.$options.name)

    /*appBackgroundを書き換える*/
    this.appBackground = this.$store.getters.pageBackgroundStyle? this.$store.getters.pageBackgroundStyle:'appBackgroundBase'

    this.$nextTick(function () {
      this.$refs.loadingView.ending()
this._log("DOM CREATED")
    })

/*vue-headがmount時のみ動くため、
子>親などの動作時にコンポーネントにセットしている内容が反映されない。
ここで、各コンポーネントに対してhead要素を更新するようにする*/
//		this.$refs.view.updateHead()
		this.$emit('updateHead')
//this._log("UPDATE HEAD")
  },

  methods: {
    openSideButton:function() {
    },
    closeSideButton:function() {
    },
    setTarget:function(target) {
      this.sideButton = target
    },
    handleScrollApp:function (evt, el) {
      if( document.body.clientWidth < 991) { el.classList.remove("icon"); return false }
      if(!this.$route.meta.interfaceParts) {
        if(window.scrollY < 51 && !this.onMouse) {
          el.classList.remove("appearInterface")
        } else {
          el.classList.add("appearInterface")
        }
      }
      return false
    },
    appearNavigation:function(event)  {
      this.$refs.interfaceParts.classList.add("appearInterface")
      this.onMouse = true
      return false
    },
    disappearNavigation:function(event)  {
        if(window.scrollY < 51 && !this.$route.meta.interfaceParts ) {
          this.$refs.interfaceParts.classList.remove("appearInterface")
          this.onMouse = false
        }
      return false
    },

/*
スマホタッチチェック
[概要]
スマホ スワイプ/フリック操作中であることを示す
[詳細]
true:スワイプ/フリック中
false:なし
*/
		tapCheck:function(event) {
			this.touchMonitor = true
		},
		toggleNavigation:function(event) {
			//startで動き出し、フリック/スワイプがない場合にタッチと判断する
			if(!this.touchMonitor) {
				this.onMouse = !this.onMouse
				this.touchMonitor = false
				this.$refs.interfaceParts.classList.toggle("appearInterface")
			} else {
				this.touchMonitor = false //一応
			}
		},
    appearLoadingView:function() {
      this.$refs.loadingView.appear()
    },
		aUpdateHead:function() {
//this._log("変更されました")
			this.$emit('updateHead')
		},
  },

//ライフサイクルチェック用に残す
//  beforeCreate: function() {this._log("beforeCreate "+this.$options.name)},
//  created:function() {this._log("created "+this.$options.name)},
//  beforeMount:function() {this._log("beforeMount "+this.$options.name)},
//  mounted:function() {this._log("mounted "+this.$options.name)},
//  beforeUpdate:function() {this._log("beforeUpdate "+this.$options.name)},
//  updated: function() {this._log("updated "+this.$options.name)},
//  beforeDestroy:function() {this._log("beforeDestroy "+this.$options.name)},
//  destroy:function() {this._log("destroy "+this.$options.name)},
//  activated:function() {this._log("activated "+this.$options.name)},
//  deactivated:function() {this._log("deactivated "+this.$options.name)},
//  beforeUnmount:function() {this._log("beforeUnmount "+this.$options.name)},
//  unmounted:function() {this._log("unmounted "+this.$options.name)},
//  errorCaptured:function() {this._log("errorCaptured "+this.$options.name)},
}
</script>

<style>
</style>
